export default "__VITE_ASSET__ab3427b6__"